import restaurantStudioRegistration
  from "./components/RestaurantStudio/restaurantStudioRegistration";

import retailStudioRegistration
  from "./components/RetailStudio/retailStudioRegistration";


export const STUDIO_REGISTRATIONS = Object.freeze([
  restaurantStudioRegistration,
  retailStudioRegistration,
]);


export function getStudioRegistrations() {
  return STUDIO_REGISTRATIONS;
}


export function getStudioRegistrationForDomain(
  domainId
) {
  if (
    typeof domainId !== "string"
    || !domainId.trim()
  ) {
    return null;
  }

  const normalizedDomainId =
    domainId.trim();

  return (
    STUDIO_REGISTRATIONS.find(
      (registration) =>
        registration?.metadata?.domainId
        === normalizedDomainId
    )
    || null
  );
}


export default STUDIO_REGISTRATIONS;
